export default {
    "fieldtypes": {
    },
    "fields": {
    },
    "layouts": {
    }
}